import { render } from "./HomePageJoinUs.vue?vue&type=template&id=71f784dc&scoped=true"
const script = {}

import "./HomePageJoinUs.vue?vue&type=style&index=0&id=71f784dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f784dc"]])

export default __exports__